import { render, staticRenderFns } from "./Dept.vue?vue&type=template&id=33fad5ed&scoped=true"
import script from "./Dept.vue?vue&type=script&lang=js"
export * from "./Dept.vue?vue&type=script&lang=js"
import style0 from "./Dept.vue?vue&type=style&index=0&id=33fad5ed&prod&scoped=true&lang=css"
import style1 from "./Dept.vue?vue&type=style&index=1&id=33fad5ed&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fad5ed",
  null
  
)

export default component.exports